module.exports = (parcelRequire.load("9pOdu")).then(() => parcelRequire('ax0EU'));